<template>
    <section class="tables new-updated-design">
        <vue-snotify></vue-snotify>
        <div class="row">
            <div class="col-lg-12 grid-margin stretch-card">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">Transaction History</h4>
                    </div>
                    <div class="card-body">
                        <div class="panel-heading">
                            <div class="row">
                                <div class="col-lg-4 col-md-6 form-group">
                                    <input type="hidden" name="autocompletePractice" id="autocompletePractice">

                                    <input class="form-control" v-model="serverParams.customFilters.name" type="text"
                                        name="search" id="search" placeholder="Member Filter" value=""
                                        @keyup="loadItems()">
                                </div>
                                <div class="col-lg-6 col-md-6 form-group" style="font-size:15px; font-weight:300;">
                                    <input class="group" name="group" value="Active" type="radio"
                                        @click="radioFilter('Active')"> Active
                                    <input class="group" name="group" value="Inactive" type="radio"
                                        @click="radioFilter('Inactive')"> Inactive
                                    <input class="group" name="group" value="Suspended" type="radio"
                                        @click="radioFilter('Suspended')"> Suspended
                                    <input class="group" name="group" checked value="Suspended" type="radio"
                                        @click="radioFilter('Everyone')"> Everyone
                                </div>
                            </div>
                        </div>
                        <CircleLoader v-if="isLoading" />
                        <vue-good-table mode="remote" :totalRows="totalRecords" :isLoading="isLoading"
                            :pagination-options="{
                                enabled: true,
                                perPage: serverParams.perPage,
                                perPageDropdown: [10, 20, 50, 100, 200],
                            }" :sort-options="{
                                enabled: true,
                                initialSortBy: {
                                    field: 'PaymentDate',
                                    type: 'desc',
                                },
                            }" :rows="rows" :columns="columns" @on-page-change="onPageChange"
                            @on-per-page-change="onPerPageChange" @on-sort-change="onSortChange">
                            <template slot="table-row" slot-scope="props">
                                <span v-if="props.column.field === 'name'">
                                    <span>{{ props.row.FirstName }} {{ props.row.LastName }}</span>
                                </span>
                                <span v-else-if="props.column.field === 'PaymentExpireDate'">
                                    <span v-for="(location, index) in props.row.payments" :key="index">
                                        <span v-if="index === Object.keys(props.row.payments).length - 1">
                                            {{ formatDate(location.PaymentExpireDate) }}
                                        </span>
                                    </span>
                                </span>
                                <span v-else-if="props.column.field === 'PaymentDate'">
                                    <span v-for="(location, index) in props.row.payments" :key="index">
                                        <span v-if="index === Object.keys(props.row.payments).length - 1">
                                            {{ formatDate(location.PaymentDate) }}
                                        </span>
                                    </span>
                                </span>
                                <span v-else-if="props.column.field === 'TotalPayment'">
                                    <span v-for="(location, index) in props.row.payments" :key="index">
                                        <span v-if="index === Object.keys(props.row.payments).length - 1">
                                            {{ dollarFn(location.TotalPayment) }}
                                        </span>
                                    </span>
                                </span>
                                <span v-else-if="props.column.field === 'user_view_m_focuses.NP_Focus1Actual'">
                                    <span v-for="(location, index) in props.row.payments" :key="index">
                                        <span v-if="props.row.MemberStatus == 'Active'">
                                            <span v-if="new Date(location.PaymentExpireDate) > new Date()"> 
                                                <span v-if="index === Object.keys(props.row.payments).length - 1">
                                                    {{ dollarFn(location.TotalPayment) }}
                                                </span>
                                            </span>
                                        </span>
                                    </span>
                                </span>
                                <span v-if="props.column.field === 'action'" class="text-nowrap">
                                    <b-button size="sm" @click="Billing_details(props.row.UserID)"
                                        class="mr-1 btn-info text-white">
                                        View Member
                                    </b-button>
                                </span>
                                <span v-else>
                                    {{ props.formattedRow[props.column.field] }}
                                </span>
                            </template>
                        </vue-good-table>

                    </div>
                </div>
            </div>
        </div>
        <div></div>
    </section>
</template>

<script>
import Vue from "vue";
import SortedTablePlugin from "vue-sorted-table";
import API from '@/api'
import { validationMixin } from "vuelidate";
import { required, minLength, email, requiredIf, sameAs } from "vuelidate/lib/validators";
import moment from 'moment'
import CircleLoader from '@/pages/loaders/CircleLoader.vue';

Vue.use(SortedTablePlugin, {
    ascIcon: '<i class="ti-arrow-down"></i>',
    descIcon: '<i class="ti-arrow-up"></i>'
});
export default {
    name: 'Spotters',
    data() {
        return {
            isDisabled: false,
            selected: true,
            unSelected: false,
            serverParams: {
                customFilters: {
                    memberStatus: '',
                    name: ''
                },
                sort: [
                    {
                        field: 'PaymentExpireDate', // example: 'name'
                        type: 'desc' // 'asc' or 'desc'
                    }
                ],

                page: 1, // what page I want to show
                perPage: 10 // how many items I'm showing per page
            },
            columns: [
                {
                    label: 'Member',
                    field: 'name',
                    sortable: true,
                    filterable: true,
                },
                {
                    label: 'Date of Next Payment',
                    field: 'PaymentExpireDate',
                    sortable: true,
                    formatFn: this.formatDate,
                },
                {
                    label: 'Date of Last Payment',
                    field: 'PaymentDate',
                    sortable: true, // Change to true if you want sorting on this field
                    formatFn: this.formatDate,
                },
                {
                    label: 'Transaction',
                    field: 'TotalPayment',
                    sortable: false, // Change to true if you want sorting on this field
                    formatFn: this.dollarFn,
                },
                {
                    label: 'Payment',
                    field: 'user_view_m_focuses.NP_Focus1Actual',
                    sortable: false,
                    type: this.dollarFn,
                },
                {
                    label: 'Action',
                    field: 'action',
                    sortable: false,
                    type: 'percentage',
                },
            ],
            isLoading: false,
            rows: [],
            totalRecords: 0,
            spots: []
        };
    },
    methods: {
        Billing_details(e) {
            this.$router.push({ name: 'Billing_details', params: { id: e } });
        },
        radioFilter(value) {
            this.serverParams.customFilters.memberStatus = value;
            this.loadItems();
        },
        loadItems() {
            this.isLoading = true;
            API.getAllBilling(this.serverParams,
                data => {
                    this.totalRecords = data.totalRecords;
                    this.rows = data.data.data;
                    this.rows.forEach(user => {
                        if (user.payments && user.payments.length > 0) {
                            // Find the latest payment based on PaymentDate
                            let latestPayment = user.payments.reduce((latest, current) => {
                                return new Date(latest.PaymentDate) > new Date(current.PaymentDate) ? latest : current;
                            });
                            // Set payments array to contain only the latest payment
                            user.payments = [latestPayment];
                        }
                    });
                    // console.log('jjjjjjj',this.rows);
                    this.isLoading = false;
                }, err => {
                    this.isLoading = false;
                })
        },
        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
        },
        onPageChange(params) {
            this.updateParams({ page: params.currentPage });
            this.loadItems();
        },
        onPerPageChange(params) {
            this.updateParams({ perPage: params.currentPerPage });
            this.loadItems();
        },
        dollarFn: function (value) {
            if (!isNaN(value) && value !== null) {
                return '$' + parseFloat(value).toFixed(2);
            } else {
                return '$0.00';
            }
        },
        formatDate(value) {
            if (value) {
                return moment(String(value)).format('MMMM DD, YYYY');
            }
        },
        onSortChange(params) {
            Vue.set(this.serverParams.sort, 0, {
                field: params[0].field,
                type: params[0].type,
            });
            this.loadItems();
        },
    },
    computed: {}
    ,
    mounted() {
        this.loadItems();
    }
}
</script>